import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 16 16', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M8.40402 2.49353C8.28136 2.42167 8.14177 2.38379 7.99962 2.38379C7.85746 2.38379 7.71787 2.42167 7.59522 2.49353L2.78722 5.30953C2.66685 5.38027 2.5671 5.48128 2.49787 5.60252C2.42864 5.72376 2.39234 5.861 2.39258 6.00062C2.39282 6.14023 2.4296 6.27735 2.49925 6.39835C2.5689 6.51934 2.66901 6.62 2.78962 6.69033L7.59682 9.49193C7.7191 9.56319 7.85809 9.60073 7.99962 9.60073C8.14115 9.60073 8.28014 9.56319 8.40242 9.49193L13.2096 6.69033C13.3303 6.61992 13.4305 6.51911 13.5001 6.39795C13.5698 6.27679 13.6065 6.1395 13.6065 5.99976C13.6066 5.86001 13.5701 5.72268 13.5006 5.60144C13.4311 5.4802 13.331 5.37928 13.2104 5.30873L8.40322 2.49273L8.40402 2.49353Z',
                    fill: '#A7ABC3',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M2.45604 7.71997L7.60724 10.6176C7.72694 10.6849 7.86193 10.7202 7.99924 10.7202C8.13655 10.7202 8.27155 10.6849 8.39124 10.6176L13.5416 7.71997C13.6191 7.89953 13.628 8.10123 13.5668 8.28695C13.5057 8.47267 13.3786 8.62956 13.2096 8.72797L8.40164 11.5296C8.27946 11.6007 8.14061 11.6381 7.99924 11.6381C7.85787 11.6381 7.71903 11.6007 7.59684 11.5296L2.78884 8.72797C2.61988 8.62956 2.4928 8.47267 2.43163 8.28695C2.37046 8.10123 2.37943 7.89953 2.45684 7.71997H2.45604Z',
                    fill: '#A7ABC3',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M2.45604 9.68237L7.60724 12.58C7.72694 12.6473 7.86193 12.6826 7.99924 12.6826C8.13655 12.6826 8.27155 12.6473 8.39124 12.58L13.5416 9.68237C13.6191 9.86193 13.628 10.0636 13.5668 10.2493C13.5057 10.4351 13.3786 10.592 13.2096 10.6904L8.40164 13.492C8.27946 13.5631 8.14061 13.6005 7.99924 13.6005C7.85787 13.6005 7.71903 13.5631 7.59684 13.492L2.78884 10.6904C2.61988 10.592 2.4928 10.4351 2.43163 10.2493C2.37046 10.0636 2.37943 9.86193 2.45684 9.68237H2.45604Z',
                    fill: '#A7ABC3',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const LayerFilled = React.forwardRef(IconComponent);
LayerFilled.displayName = 'LayerFilled';

export { LayerFilled };
